// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__OZWYk","loader":"Loader_loader__DwtSp","spin":"Loader_spin__ddwRw"};